import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = { class: "error-container" }

import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElButton } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const router = useRouter();

onMounted(() => {
    console.log('404页面组件挂载完成');
});

const goHome = () => {
    router.push('/home');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "404", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "抱歉，您访问的页面不存在", -1)),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: goHome
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("返回首页")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})